import { Item } from "./proposals.api";

export interface Proposals {
    items?: ProposalModel[];
    pagination?: Pagination;
}

export interface ProposalModel {
    propose_id?: number;
    propose_code?: string;
    representative_id?: string;
    recipient_id?: number | null;
    recipient_name?: null | string;
    effective_from?: Date;
    effective_to?: Date;
    status?: string;
    created_at?: Date;
    updated_at?: Date;
}

export interface Pagination {
    page?: number;
    page_size?: number;
    total?: number;
    total_pages?: number;
}

export const ConvertProposals = (data: Item[] = []): ProposalModel[] => {
    if (!Array.isArray(data)) return [];
    return data.map((item): ProposalModel => ({
        propose_id: item?.propose_id ?? 0,
        propose_code: item?.propose_code ?? "",
        representative_id: item?.representative_id ?? "",
        recipient_id: item?.recipient_id ?? 0,
        recipient_name: item?.recipient_name ?? "",
        effective_from: item?.effective_from ?? new Date(),
        effective_to: item?.effective_to ?? new Date(),
        status: item?.status?.toString().toLowerCase() ?? "closed",
        created_at: item?.created_at ?? new Date(),
        updated_at: item?.updated_at ?? new Date(),
    }));
};
